import React from 'react'
import { useApplicationContext } from '../../context/ApplicationContext';
import { Box, Button, Dialog, getContrastRatio, IconButton, InputAdornment, TextField, Typography, useTheme } from '@mui/material';
import useErrorHandler from '../../api/errorHandler/useErrorHandler';
import { useState } from 'react';
import { addLabel_API, getLabelList_API, updateDeleteLabel_API } from '../../api/controller/SettingsController';
import { HttpStatusCode } from 'axios';
import { Severity } from '../../constant/ApplicationVariables';
import { useEffect } from 'react';
import { font } from '../../styles/font';
import { CloseOutlined } from '@mui/icons-material';
import { HexColorPicker } from 'react-colorful';

export default function AddUpdateLabelDialog({ open, data, isEdit, handleClose }) {
    const { activeProject, labelList, setLabelList, handleSnackbar } = useApplicationContext();

    const theme = useTheme();
    const errorHandler = useErrorHandler();


    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [labelName, setLabelName] = useState("");
    const [labelColor, setLabelColor] = useState("#FF5733");
    const [currentLabelData, setCurrentLabelData] = useState(null);
    const [color, setColor] = useState("#aabbcc");


    function handleCloseDialog() {
        handleClose();
    }

    const handleSubmitDialog = () => {
        if (isEditMode) {
            handleContinueUpdate();

        } else {
            handleContinueAdd();
        }
    }


    const handleGetList = async () => {

        try {

            setLoading(true)


            let body = {
                name: activeProject?.name,
            }

            let query = new URLSearchParams(body).toString();

            const response = await getLabelList_API(query);

            console.log(response, " response in updateprofile")

            if (response) {
                errorHandler(response, setLoading);
            }

            if (response.status === HttpStatusCode.Ok) {
                setLabelList(response.data);
                handleClose();

            }

        } catch (error) {
            console.log(error, error?.message, "login errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);

            }, 1000);
        }
    }

    const handleContinueAdd = async () => {

        try {

            setLoading(true);


            let body = {
                name: labelName,
                colorCode: color,
                projectName: activeProject?.name,
            }

            const response = await addLabel_API(body);

            console.log(response, " response in updateprofile")

            if (response) {
                errorHandler(response, setLoading);
            }

            if (response.status === HttpStatusCode.Ok) {

                handleCloseDialog();
                handleGetList();


                handleSnackbar(response?.data?.message, Severity.success);
            }

        } catch (error) {
            console.log(error, error?.message, "login errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);

            }, 1000);
        }
    }

    const handleContinueUpdate = async (isDelete) => {

        try {

            setLoading(true);


            let body = {
                currenName: currentLabelData?.name,
                newName: labelName,
                colorCode: color,
                projectName: activeProject?.name,

                delete: isDelete,
                lastModifiedAt: currentLabelData?.lastModifiedAt ? currentLabelData?.lastModifiedAt : null
            }

            if (currentLabelData?.name === labelName) {
                delete body.newName;
            }

            const response = await updateDeleteLabel_API(body);

            console.log(response, " response in updateprofile")

            if (response) {
                errorHandler(response, setLoading);
            }

            if (response.status === HttpStatusCode.Ok) {

                handleCloseDialog();
                handleGetList();


                handleSnackbar(response?.data?.message, Severity.success);
            }

        } catch (error) {
            console.log(error, error?.message, "login errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);

            }, 1000);
        }
    }


    useEffect(() => {
        if (data && isEdit) {
            setIsEditMode(true);
            setCurrentLabelData(data);
            setLabelName(data?.name);
            setColor(data?.colorCode);
        } else {
            setIsEditMode(false);
            setCurrentLabelData(null);
            setLabelName("");
            setColor("#FF5733");
        }
    }, [data, isEdit]);


    return (
        <Dialog
            open={open}
            onClose={() => handleCloseDialog()}
            PaperProps={{
                sx: {
                    maxWidth: "400px",
                    width: "100%",
                }
            }}
        >
            <Box className="flex flex-col gap-4 p-4 min-w-full max-w-96">
                {/* header */}
                <Box className="flex items-center justify-between gap-4 ">
                    <Typography fontSize={font.size.fs_5} color={"textSecondary"}>{isEditMode ? "Edit" : "Add"} Label</Typography>
                    <IconButton onClick={() => handleCloseDialog()}>
                        <CloseOutlined />
                    </IconButton>
                </Box>

                {/* body */}
                <Box className="flex-1 flex flex-col gap-4 ">
                    <TextField placeholder="Name" autoFocus value={labelName} onChange={(e) => setLabelName(e.target.value)} />
                    {/* color */}

                    <Box className="flex gap-4">
                        <HexColorPicker color={color} onChange={setColor} />

                        <Box className="flex flex-col gap-4">
                            <Box className="flex-1  flex items-center justify-center" borderRadius={theme.shape.borderRadius} bgcolor={color} >
                                <Typography fontSize={font.size.fs_5} color={getContrastRatio(color, '#FFFFFF') < 4.5 ? '#000000' : '#FFFFFF'}>Label Color </Typography>
                            </Box>

                            <TextField
                                // value={color?.replace("#", "")}
                                // onChange={(e) => setColor(e.target.value.includes("#") ? e.target.value : "#" + e.target.value)}
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                                startAdornment={
                                    <InputAdornment position="start">
                                        #
                                    </InputAdornment>
                                }
                            />
                        </Box>

                    </Box>
                </Box>
                {/* footer */}
                <Box className="flex-1 flex items-center justify-between gap-4 ">
                    <Button variant="outlined">Cancel</Button>
                    <Button variant="contained" color="secondary" sx={{ color: theme.palette.secondary.contrastText }} onClick={handleSubmitDialog}>{isEditMode ? "Update" : "Continue"}</Button>
                </Box>
            </Box>
        </Dialog>
    )
}
